import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';

// Logo component - Updated to circular version
const Logo = () => (
  <img 
    src="/mushonga_logo_circular.png"
    alt="Mushonga Systems"
    className="h-10 w-auto"
  />
);

const FreeReviewSuccessPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col" data-testid="free-review-success-page">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-40 glass">
        <div className="section-container">
          <nav className="flex items-center justify-between py-4">
            <Link to="/" className="flex items-center gap-3">
              <Logo />
              <span className="text-white font-bold text-lg hidden sm:block">
                Mushonga Systems
              </span>
            </Link>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center pt-20 pb-12 px-4">
        <div className="max-w-lg mx-auto text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-emerald-500/20 border-2 border-emerald-500 rounded-full flex items-center justify-center mx-auto mb-8 animate-pulse">
            <CheckCircle2 className="text-emerald-400" size={40} />
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tighter text-white mb-4">
            Thank You
          </h1>

          {/* Message */}
          <p className="text-gray-400 text-lg leading-relaxed mb-4">
            Your review request has been received successfully.
          </p>

          <p className="text-gray-500 mb-8">
            We will review your business and get back to you within <span className="text-emerald-400 font-semibold">48 hours</span>.
          </p>

          {/* What happens next */}
          <div className="bg-[#111827] border border-white/10 rounded-xl p-6 mb-8 text-left">
            <h3 className="text-white font-semibold mb-4">What happens next?</h3>
            <ol className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-emerald-500/20 rounded-full flex items-center justify-center flex-shrink-0 text-emerald-400 text-xs font-bold">1</span>
                <span className="text-gray-400">We analyse your website, systems and customer journey</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-emerald-500/20 rounded-full flex items-center justify-center flex-shrink-0 text-emerald-400 text-xs font-bold">2</span>
                <span className="text-gray-400">We prepare personalised recommendations for your business</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 bg-emerald-500/20 rounded-full flex items-center justify-center flex-shrink-0 text-emerald-400 text-xs font-bold">3</span>
                <span className="text-gray-400">We send you a detailed review within 48 hours</span>
              </li>
            </ol>
          </div>

          {/* Check email notice */}
          <p className="text-gray-600 text-sm mb-8">
            A confirmation email has been sent to your inbox.
          </p>

          {/* CTA */}
          <Link
            to="/"
            className="btn-primary inline-flex"
            data-testid="return-home-button"
          >
            Return To Website
            <ArrowRight size={18} />
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 border-t border-white/10">
        <div className="section-container">
          <div className="text-center">
            <p className="text-gray-600 text-xs">
              © {new Date().getFullYear()} Mushonga Systems. All rights reserved.
            </p>
            <p className="text-gray-600 text-[10px] mt-1">
              Mushonga Systems is a trading name of ATM29 LTD. Registered in England and Wales. Company No. 13457210.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FreeReviewSuccessPage;
